<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-data.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">數據治理諮詢與實施服務</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">數據治理諮詢與實施服務</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						數據治理諮詢與實施服務聚焦於解決企業數據碎片化、質量低下、安全風險及合規隱患等問題，通過制定戰略、設計流程、部署技術工具，實現數據從採集到銷毀的全生命週期管理，確保業務決策的可靠性與高效率。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">業務挑戰</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據戰略與體系轉型困難</div>
										<div class="t2">
											企業缺乏統一的數據頂層戰略規劃和系統化的數據治理體系，未建立健全的數據管理機制與體系，導致數據管理碎片化，無法有效支撐企業的長遠發展和數字化轉型目標
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據質量和安全性風險高</div>
										<div class="t2">
											數據質量不穩定，且安全性難以保障，特別是在多系統集成和跨部門協作中，數據錯誤和數據洩露風險增大，給企業帶來潛在的法律和合規風險
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">複雜流程管理難度大</div>
										<div class="t2">
											企業面臨海量數據和複雜業務流程的管理挑戰，數據源繁多且分散，數據一致性難以保障，導致決策滯後和業務運作效率低下。
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據治理諮詢與實施服務</div>
										<div class="t2">
											以高階專業視角定制解決方案，結合行業最佳實踐，覆蓋數據全生命週期管理，確保策略落地執行，助力企業構建高效、可持續的數據管理體系，推動數字化轉型
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/data2-1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">客戶價值</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/data2-2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">全面資產盤點落地</div>
										<div class="t2">
											識別並分類企業的全部數據資源，建立全面的數據資產目錄，確保對數據資源的全面掌控，為有效管理和利用數據資產打下堅實基礎
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">實施數據資產標準化</div>
										<div class="t2">
											制定並執行統一的數據標準，規範數據定義和格式，消除冗餘和不一致性，實現跨部門和跨系統的數據一致性，為企業提供標準化的數據基礎
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據質量監控提升</div>
										<div class="t2">
											運用高效率檢測工具和方法對數據進行清洗、校驗和監控，增強數據的準確性、完整性和一致性，解決數據質量問題，確保業務決策的可靠性和效率
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據應用體系構建</div>
										<div class="t2">
											針對特定行業場景，構建數據應用（數據指標）體系，確保關鍵業務數據準確反映企業的運營狀況，支持決策層進行深入分析和科學決策，推動數據驅動的業務增長與優化
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
